/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import {
    Button,
    ButtonGroup,
    ModalActions,
    Stack,
    StyledModal,
    Text,
} from 'sarsaparilla';

//TODO: If ATB changes pricing, the information need to be updated
export function NonResidentFeeATBModal({ isOpen, onClose, onContinue, onLearnMore }) {
    return (
        <StyledModal
            heading="You have selected more than two non-U.S. residents"
            size="md"
            isOpen={isOpen}
            onRequestClose={onClose}
            shouldActionsStickInMobile
        >
            <Stack>
                <Text>
                    This puts your total cost for this purchase above $200. You may save
                    money by purchasing an America the Beautiful annual or lifetime Pass
                    instead.
                </Text>
            </Stack>

            <ModalActions>
                <ButtonGroup isFullWidthOnMobile isStretchedToFit>
                    <Button appearance="tertiary" onClick={onContinue}>
                        Continue with This Purchase
                    </Button>
                    <Button onClick={onLearnMore}>Learn More About ATB Passes</Button>
                </ButtonGroup>
            </ModalActions>
        </StyledModal>
    );
}
